import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RomeEndpointConfigItem } from '../utils/interfaces';

@Injectable({
  providedIn: 'root'
})
export class RomeUiLoaderService {
  public showLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public customRomeEndpointConfigItem: RomeEndpointConfigItem;

  start(): void {
    this.showLoading$.next(true);
  }

  stop(): void {
    this.showLoading$.next(false);
  }

  setCustomUiLoaderConfigItem(customRomeEndpointConfigItem: RomeEndpointConfigItem): void {
    this.customRomeEndpointConfigItem = customRomeEndpointConfigItem;
  }
}
